const DeviceScreenMaxWidth = {
  mobile: '480px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1200px'
};

export default DeviceScreenMaxWidth;
